<template>
    <div class="lg:flex container mx-auto py-4 lg:space-x-4 px-2 md:px-0">
        <div class="lg:w-2/3">
            <jet-form-main @submitted="pageCreate">
                <template #title>
                </template>

                <template #description>
                </template>
                
                <template #form>
                    <!-- Title -->
                    <div>
                        <jet-label for="title" value="Título" class="font-bold" />
                        <jet-input type="text" v-model="form.title" class="w-full"/>
                        <jet-input-error :message="form.errors.title" />
                    </div>
                </template>
            </jet-form-main>

            <div class="mt-4 bg-white shadow rounded-lg p-6" v-if="page != null">
                <div class="flex flex-row items-center justify-between">
                    <h3 class="block font-medium text-sm text-gray-700 font-bold">Secções</h3>

                    <jet-button class="!bg-white border !border-primary-900 !text-primary-900" @click.prevent="showSectionModal = true">Inserir Secção</jet-button>
                </div>

                <!-- sections -->
                <div v-for="section in page.sections" class="mt-4 shadow-lg p-4 rounded-lg flex flex-row justify-between items-center">
                    <h4 class="font-bold">{{ section.name }}</h4>
                    <div>
                        <button @click.prevent="showSectionEdit(section.id)" class="mr-2"><icon name="edit" class="w-6 h-6 text-violet-500 p-1 rounded-full border border-violet-500" /></button>
                        <button @click.prevent="deleteSection(section.id)"><icon name="trash" class="w-6 h-6 text-red-500 p-1 rounded-full border border-red-500" /></button>
                    </div>
                </div>

                <!-- Modal -->
                <jet-dialog-modal :show="showSectionModal" @close="showSectionModal = false">
                    <template #title>
                        <!-- <span v-if="this.sec != null">Atualizar Secção</span><span v-else>Inserir Secção</span> -->
                    </template>

                    <template #content>
                        <label class="form-label text-sm font-bold">Nome</label>
                        <jet-input type="text" v-model="section.name" class="w-full" />

                        <label class="form-label text-sm font-bold">Corpo</label>
                       <!--  <vue-editor v-model="section.content" /> -->

                        <textarea v-model="section.content"></textarea>
                       <!-- <editor
                            api-key="no-api-key"
                            v-model="section.content"
                            :init="{
                            height: 500,
                            menubar: false,
                            branding: false,
                            content_css: '/css/app.css',
                            language: 'pt_PT',
                            extended_valid_elements : '*[*]',
                            forced_root_block : 'span',
                            encoding: 'UTF-8',
                            plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount link template'
                            ],
                            toolbar:
                            ['undo redo | formatselect | removeformat bold italic forecolor | \
                            alignleft aligncenter alignright | \
                            bullist numlist | image link | code template'],
                            templates: [
                                {title: 'Artigos em destaque', description: '', content: posts},
                                
                              ]
                            }"
                        /> -->
                        <button @click.prevent="addTwoCols">2 colunas</button>
                    </template>

                    <template #footer>
                        <jet-secondary-button @click="closeSectionModal">
                            Cancelar
                        </jet-secondary-button>

                        <jet-button @click.prevent="insertSection" class="ml-2"><span v-if="this.sec != null">Atualizar</span><span v-else>Inserir</span></jet-button>
                    </template>
                </jet-dialog-modal>
            </div>
        </div>

        <div class="px-4 py-5 bg-white sm:p-6 shadow rounded-md mt-1 relative h-full lg:flex-1">

            <div class="flex items-center space-x-2">
                <label for="checked-toggle" class="inline-flex relative items-center cursor-pointer">
                    <jet-checkbox v-model="form.is_published" :checked="form.is_published == 1 ? true : false" id="checked-toggle" class="sr-only peer" />
                    <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-transparent dark:peer-focus:ring-primary-900 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-violet-500"></div>
                    <span class="ml-3 text-sm font-medium text-violet-500 dark:text-violet-100 uppercase" v-if="form.is_published == 1">Público</span>
                    <span class="ml-3 text-sm font-medium text-gray-300 dark:text-gray-300 uppercase" v-else>Rascunho</span>
                </label>
            </div>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="relative bottom-0 bg-primary-900 text-center w-full justify-center text-lg tracking-normal mt-10 rounded-full" @click.prevent="pageUpdate" v-if="page">Atualizar</jet-button>
            
            
            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="relative bottom-0 bg-primary-900 text-center w-full justify-center text-lg tracking-normal mt-10 rounded-full" @click.prevent="pageCreate" v-else>Criar</jet-button>

            <div class="flex justify-between mt-4">
                <jet-button @click.prevent="backToPages()" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-violet-500 px-0"><icon name="back" />Voltar</jet-button>

                <jet-button v-if="page" @click.prevent="removePage(page)" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-amber-600 px-0"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
            </div>

        </div>
    </div>
</template>

<style>
    .ql-toolbar.ql-snow {
        border-radius: 0.375rem 0.375rem 0 0;
    }
    .ql-container.ql-snow {
        border-radius: 0 0 0.375rem 0.375rem;
    }
</style>

<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetActionMessage from '@/Jetstream/ActionMessage.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetFormMain from '@/Jetstream/MainForm.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetModal from '@/Jetstream/Modal.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import Icon from '@/Jetstream/Icon'
    import FileInput from '@/Components/FileInput.vue'
    import { VueEditor, Quill } from "vue3-editor"
    import Editor from '@tinymce/tinymce-vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            JetInput,
            TextAreaInput,
            JetLabel,
            JetActionMessage,
            JetButton,
            JetFormMain,
            JetInputError,
            JetModal,
            JetCheckbox,
            JetDialogModal,
            JetSecondaryButton,
            Icon,
            VueEditor,
            FileInput
        },
        layout: BackLayout,
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            categories: Array,
            page: Object,
            feat_posts: Array
        },
        data() {
            return {
                showSectionModal: false,
                form: this.$inertia.form({
                    title: '',
                    is_published: false
                }),
                section: this.$inertia.form({
                    name: '',
                    content: '',
                    order: null,
                }),
                sec: null,
                altcontent: ''
            }
        },
        computed: {
        },
        created() {
            if(this.page != null) {
                this.form.title = this.page.title
                this.form.is_published = this.page.is_published
            }
            if(this.sec){
                this.section.content = this.parse(this.sec)
            }
        },
        methods: {
            pageCreate() {
                this.form.post(route('store.page'), {
                    errorBag: 'pageCreate',
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                    onError: () => {
                    }
                })
            },
            pageUpdate() {
                this.form.post(route('update.page', this.page ), {
                    method: 'PUT',
                    errorBag: 'pageUpdate',
                    preserveScroll: true
                })
            },
            removePage(page) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('destroy.page', page));
                }
            },
            backToPages() {
                this.$inertia.get(route('pages.index'))
            },
            insertSection() {
                if(this.sec != null) {
                    this.section.put(route('sections.update', this.sec), {
                        errorBag: 'insertSection',
                        preserveScroll: true,
                        onSuccess: () => {
                            this.section.reset(),
                            this.showSectionModal = false,
                            this.sec = null
                        },
                    })
                } else {
                    this.section.post(route('sections.store', {'page_id': this.page}), {
                        errorBag: 'insertSection',
                        preserveScroll: true,
                          onSuccess: () => {
                            this.section.reset(),
                            this.showSectionModal = false,
                            this.sec = null
                        },
                    })
                }
                
            },
            showSectionEdit(id) {
                this.page.sections.filter(sec => {
                    if(sec.id == id) {
                        this.sec = id
                        this.showSectionModal = true
                        this.section.name = sec.name
                        this.section.content = sec.content 
                    }
                })
            },
            deleteSection(id) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.section.delete(route('sections.destroy', id, {'page_id': this.page}), {
                        errorBag: 'deleteSection',
                        preserveScroll: true,
                        onSuccess: () => {
                            this.section.reset(),
                            this.showSectionModal = false,
                            this.sec = null
                        },
                    })
                }
            },
            closeSectionModal() {
                this.showSectionModal = false
                this.section.reset()
                this.sec = null
            },
            parse(html) {
              return html.replace(/{{(.+?)}}/g, (_, g) => {
                return this[g.trim()];
              });
            },
            addTwoCols() {
                this.section.content += this.parse('<div class="flex items-center"><div>coluna 1</div><div>coluna2</div></div>')
            }

        },
    })
</script>